
const CONTENT_WIDTH = '300px';

export const getStyles = (theme) => ({
    mainContainer: {
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
        backgroundColor: '#F8FAFC',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    body: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        padding: '16px',
    },
    signinContainer: {
        width: '420px',
        maxWidth: '100%',
        backgroundColor: '#FFFFFF',
        borderRadius: '16px',
        border: '1px solid #E2E8F0',
        boxShadow: '0 4px 6px -1px rgba(0,0,0,0.07), 0 2px 4px -2px rgba(0,0,0,0.05)',
    },
    cardContent: {
        padding: '32px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    usersigninContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
        borderRadius: '16px',
    },
    actionGroup: {
        width: CONTENT_WIDTH,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
    },
    formField: {
        width: CONTENT_WIDTH,
    },
    primaryButton: {
        width: CONTENT_WIDTH,
        height: '44px',
        borderRadius: '10px',
        textTransform: 'none',
        backgroundColor: "#0B51C5",
        color: "#FFFFFF",
        '&:hover': {
            backgroundColor: "#0842a0",
        },
        '&.Mui-disabled': {
            backgroundColor: "#0B51C5",
            color: "#FFFFFF",
            opacity: 0.6,
        },
    },
    secondaryButton: {
        width: CONTENT_WIDTH,
        height: '44px',
        borderRadius: '10px',
        textTransform: 'none',
        backgroundColor: '#FFFFFF',
        border: `1px solid ${"#0B51C5"}`,
        color: "#0B51C5",
        '&:hover': {
            backgroundColor: '#F8FAFC',
            border: `1px solid ${"#0B51C5"}`,
        },
    },
    buttonLabel: {
        fontSize: '14px',
        fontWeight: 700,
        letterSpacing: '0.02em',
        color: 'inherit',
    },
    signinButton: {
        border: '1px solid #E2E8F0',
        borderRadius: '10px',
        padding: '10px 16px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        width: CONTENT_WIDTH,
        transition: 'all 0.15s ease',
        '&:hover': {
            backgroundColor: '#F8FAFC',
            borderColor: '#CBD5E1',
            boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)',
        },
    },
    footer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '10%',
        padding: '0px 10px 10px 10px',
    },
    paraText: {
        fontSize: '0.8125rem',
        fontWeight: 400,
        color: '#475569',
    },
    btnText: {
        fontSize: '0.8125rem',
        fontWeight: 400,
    },
    linkText: {
        fontSize: '0.8125rem',
        fontWeight: 500,
        color: '#2563EB',
        cursor: 'pointer',
        textAlign: 'center',
        "&:hover": {
            textDecoration: 'underline',
        },
    },
    linkGroup: {
        width: CONTENT_WIDTH,
        marginTop: '24px',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        columnGap: '12px',
        rowGap: '8px',
    },
    linkDivider: {
        width: '1px',
        height: '12px',
        backgroundColor: '#CBD5E1',
    },
    termsText: {
        maxWidth: CONTENT_WIDTH,
        marginTop: '20px',
        textAlign: 'center',
        fontSize: '13px',
        fontWeight: 400,
        color: '#475569',
        lineHeight: 1.6,
    },
    loginButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '10px',
        padding: '10px 20px',
        cursor: 'pointer',
        height: '44px',
        width: CONTENT_WIDTH,
        backgroundColor: "#0B51C5",
        color: "#FFFFFF",
        border: 'none',
        transition: 'all 0.15s ease',
        '&:hover': {
            backgroundColor: "#0842a0",
        },
    },
})
